<template>
  <pagination
    v-if="countItems >= perPage"
    count-text="Mostrando {from} a {to} de {count} registros"
    :page="page"
    :records="countItems"
    :per-page="perPage"
    @paginate="emitEvent"
    :theme="theme"/>
</template>

<script>
export default {
  name: 'Paginator',
  props: {
    count: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      theme: 'bootstrap4',
      page: 1
    }
  },
  methods: {
    emitEvent (page) {
      this.page = page
      this.$emit('exchange', page)
    }
  },
  computed: {
    countItems () {
      return this.count
    }
  }
}
</script>

<style>
.VuePagination__pagination-item-prev-chunk{
  display:none
}
.VuePagination__pagination-item-next-chunk{
  display:none
}
.VuePagination__count {
  display: none
}
</style>
